import { Editor } from '@tiptap/react';
import { prosemirrorToYDoc } from 'y-prosemirror';
import tiptapExtensions from '../Extensions/index.js';

const getYdocFromHtmlContent = (htmlContent) => {
  const editor = new Editor({
    extensions: tiptapExtensions,
    content: htmlContent
  });
  const yDoc = prosemirrorToYDoc(editor.view.state.doc, "default");
  editor.destroy();
  return yDoc;
};

export { getYdocFromHtmlContent };
//# sourceMappingURL=getYDocFromHtmlContent.js.map
